export default {"src":"/_next/static/media/home-stats-mobile-1.623f40ba.svg","height":264,"width":327,"blurWidth":0,"blurHeight":0};